import $ from "jquery";

export const initLoadMore = () => {
    const noscriptOnlyElements = $('.do-make-opaque-on-load-more-init');

    if (noscriptOnlyElements.length > 0) {
        noscriptOnlyElements.css({opacity: 0});
    }

    $('.do-show-more-button').click((event) => {
        const target = $(event.target);
        const postData = JSON.parse(target.attr('data-json'));
        const url = target.attr('data-url');
        const parentSelector = target.attr('data-parent-selector');
        const contentSelector = target.attr('data-content-selector');

        event.preventDefault();

        $.post(url, postData, (response) => {
            const container = target.parents(parentSelector).find(contentSelector);

            container.append(response.data.html);

            if (!response.data.hasMore) {
                target.remove();
            }

            postData.offset = Number(postData.offset) + Number(postData.limit)

            target.attr('data-json', JSON.stringify(postData));
        });
    })
}
